import React, { useEffect, useState } from "react";
import axios from "axios";
import { TrendingCoins } from "../../config/api";
import { CryptoState } from "../../CryptoContext";
import { Link } from "react-router-dom";
import { formatNumber, getCurrencySymbol } from "../../utils/formatters";
import classNames from "./style.module.css";

const styles = {
  carousel: {
    height: "50%",
    display: "flex",
    alignItems: "center",
  },
  card: {
    padding: 30,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
};

const Carousel = () => {
  const [trending, setTrending] = useState([]);

  const { currency } = CryptoState();
  const fetchTrendingCoins = async () => {
    const { data } = await axios.get(TrendingCoins(currency));
    setTrending(data);
  };
  useEffect(() => {
    fetchTrendingCoins();
  }, [currency]);

  return (
    <div className={classNames.slider}>
      <div className={classNames.slideTrack}>
        {trending.map((coin) => {
          const isProfit = coin.price_change_percentage_24h > 0;
          return (
            <div className={classNames.slide}>
              <Link to={`/coin/${coin.id}`}>
                <div style={styles.card}>
                  <img
                    src={coin.image}
                    alt="logo"
                    height="80"
                    style={{ marginBottom: 10 }}
                  />
                  <div style={{ color: isProfit ? "green" : "red" }}>
                    {isProfit && "+"}
                    {coin.price_change_percentage_24h.toFixed(2)}%
                  </div>
                  <div>{coin.name}</div>
                  <div>
                    {getCurrencySymbol(currency)}
                    {formatNumber(coin.current_price)}
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
        {trending.map((coin) => {
          const isProfit = coin.price_change_percentage_24h > 0;
          return (
            <div className={classNames.slide}>
              <Link to={`/coin/${coin.id}`}>
                <div style={styles.card} className={classNames.card}>
                  <img
                    src={coin.image}
                    alt="logo"
                    height="80"
                    style={{ marginBottom: 10 }}
                  />
                  <div style={{ color: isProfit ? "green" : "red" }}>
                    {isProfit && "+"}
                    {coin.price_change_percentage_24h.toFixed(2)}%
                  </div>
                  <div>{coin.name}</div>
                  <div>
                    {getCurrencySymbol(currency)}
                    {formatNumber(coin.current_price)}
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Carousel;
